---
title: 🚤 2026 USA World Jet River Race Championship — Comms Volunteer Opportunity
date: 2026-05-07
endDate: 2026-05-17
location: Multiple locations across Idaho — Emmett, Riggins, Lewiston, St. Maries
description: The 2026 USA World Jet River Race Championship spans 10 days and five Idaho rivers. DSARC members are invited to volunteer as communications operators for this international event featuring boats from the US, Canada, Mexico, and New Zealand. 📡🚤
published: true
featured: true
---

# 🚤 2026 USA World Jet River Race Championship

## A Rare EmComm Volunteer Opportunity

The **2026 USA World Jet River Race Championship** is coming to Idaho — and they need ham radio operators! This international event spans **10 days across five rivers** and features boats from the US, Canada, Mexico, and New Zealand. DSARC members are encouraged to participate as communications volunteers for as many legs as possible.

> **Comms Volunteer Signup is LIVE:** [Sign up here](https://forms.gle/x7hCHAL7waWWRJJJA)

---

## 📅 Full Schedule

> *Tentative agenda — some locations may change based on water conditions.*

### Thursday, May 7 — Emmett, ID
- Capsule Training / Pre-Running
- Race team introduction meeting
- Registration & Tech Inspections

---

### Friday, May 8 — Emmett, ID *(Black Canyon Reservoir)*
- **9:00 AM MST** — Time Trials, Test & Tune Day; Registration & Tech Inspections
- **5:00 – 8:00 PM MST** — ⚓ Opening Ceremony: Boat Show & Shine, Benefit Auction, Concert
  - 📍 The Roadhouse at the Mill, 520 W. Main Street, Emmett, ID

---

### Saturday, May 9 — Emmett / Horseshoe Bend, ID *(Payette River — Leg 1 & 2)*
- **9:00 AM MST** — Race: Black Canyon Reservoir → Horseshoe Bend (Leg 1 Up)
- **11:00 AM MST** — Race: Horseshoe Bend → Black Canyon Reservoir (Leg 2 Down)
- **2:00 PM MST** — Race: Black Canyon Reservoir → Horseshoe Bend (Leg 3 Up)
- **4:00 PM MST** — Race: Horseshoe Bend → Black Canyon Reservoir (Leg 4 Down)

*First time in 32 years the Payette River has hosted jet boat racing!*

---

### Sunday, May 10 — Emmett / Horseshoe Bend, ID *(Payette River — Leg 3 & 4)*
- **9:00 AM MST** — Race: Black Canyon Reservoir → Horseshoe Bend (Leg 1 Up)
- **11:00 AM MST** — Race: Horseshoe Bend → Black Canyon Reservoir (Leg 2 Down)

---

### Monday, May 11 — Riggins / Whitebird, ID *(Salmon River)*
- Travel Day / Pre-Running
- **4:00 – 7:00 PM PST** — 🚤 Boat Show & Shine at Silver Dollar Bar, Whitebird

---

### Tuesday, May 12 — Whitebird, ID *(Salmon River)*
- **9:00 AM PST** — Race: Hammer Creek (Whitebird) → Lucile (Leg 1 Up)
- **11:00 AM PST** — Race: Lucile → Hammer Creek (Leg 2 Down)
- **2:00 PM PST** — Race: Hammer Creek → Lucile (Leg 3 Up)
- **4:00 PM PST** — Race: Lucile → Hammer Creek (Leg 4 Down)

---

### Wednesday, May 13 — Lewiston, ID *(Snake River)*
- Travel Day / Pre-Running
- **4:00 – 7:00 PM PST** — 🚤 Boat Show & Shine at Hells Canyon Grand Hotel, Lewiston

---

### Thursday, May 14 — Lewiston, ID *(Snake River)*
- **9:15 AM PST** — Race: Hells Gate Marina → Bear Bar (Leg 1 Up)
- **11:15 AM PST** — Race: Bear Bar → Hells Gate Marina (Leg 2 Down)
- **1:30 PM PST** — Circuit Racing at Hells Gate Marina

---

### Friday, May 15 — St. Maries, ID
- Travel Day / Pre-Running
- **6:00 – 8:00 PM PST** — 🚤 Boat Show & Shine on Main St. (6th–10th Street), St. Maries

---

### Saturday, May 16 — St. Maries, ID *(St. Joe River)*
- **9:00 AM PST** — Race: St. Maries → Calder (Leg 1 Up)
- **11:00 AM PST** — Race: Calder → St. Maries (Leg 2 Down)
- **2:00 PM PST** — Race: St. Maries → Calder (Leg 3 Up)
- **4:00 PM PST** — Race: Calder → St. Maries (Leg 4 Down)

---

### Sunday, May 17 — St. Maries, ID *(St. Joe River)*
- **9:00 AM PST** — Race: St. Maries → Calder (Leg 1 Up)
- **11:00 AM PST** — Race: Calder → St. Maries (Leg 2 Down)
- 🏆 **Closing Ceremony & Awards**

---

## 📻 Comms Volunteer Info

Ham radio operators are the backbone of safety communications for these races. As a comms volunteer you'll provide:

- Real-time safety and race communications along the river
- Net control support and relay operations
- EmComm experience in a real-world, high-stakes environment

**Comms Director:** Tim Rynearson, N7UBO
*(Riggins Comms Director since 2005, Lewiston Comms Director since 2011, Worlds Comms Director 2026)*

> Sign up for as many legs as you can — more operators means better coverage and safer racing!

**[📝 Comms Volunteer Sign-Up (OPEN NOW)](https://forms.gle/x7hCHAL7waWWRJJJA)**

---

## 🔗 Resources & Links

- [Jetboat Racing USA — Official Site](https://www.jetboatracingusa.com/)
- [Comms Volunteer Sign-Up](https://forms.gle/x7hCHAL7waWWRJJJA)

---

## 📬 Questions

Questions about DSARC participation? Reach out via our [contact page](/contact) or on [Discord](https://discord.gg/432vsVAuwZ).